import { useCallback } from 'react'

import {
  LogoDigitizationSetting,
  LogoStatus,
} from '../../../../__generated__/graphql/catalog/graphql'
import { DTCLogoSetupFormValues } from '../../../../containers/EmbroideryService/types'

type UploadLogoResponse = {
  digitizationSetting: LogoDigitizationSetting
  id: string
  name: string
  notes: string
  preview: string
  priorityProcessing: boolean
  shopifyCustomerId: string
  status: LogoStatus
}

type UploadLogoInput = Pick<
  Required<DTCLogoSetupFormValues>,
  'file' | 'name' | 'digitization_setting' | 'notes'
>

/**
 * Upload a new DTC embroidery logo.
 */
export default function useEmbroideryLogoUpload() {
  const uploadLogo = useCallback(async (values: UploadLogoInput) => {
    try {
      const formData = new FormData()
      formData.set('file', values.file ?? '')
      formData.set('name', values.name ?? '')
      formData.set('digitization_setting', values.digitization_setting ?? '')
      formData.set('notes', values.notes ?? '')

      const clientApiBaseUrl = process.env.NEXT_PUBLIC_CLIENT_API_BASE_URL
      const url = `${clientApiBaseUrl}/api/embroidery/v1/logos`

      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      })
      const data: UploadLogoResponse = await response.json()
      if (response.ok) {
        return {
          ...data,
          digitizationSetting: data.digitizationSetting,
        }
      } else {
        throw new Error(response.statusText)
      }
    } catch (error) {
      throw new Error(error)
    }
  }, [])

  return uploadLogo
}
